module.exports = __webpack_public_path__ + "img/embaixo5.5844d090.jpg";